import React from 'react';
import Typography from '@material-ui/core/Typography';
import LoadingGif from '../images/Loading.gif';

export default ({ message = '' }) => (
  <div
    style={{
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    <img src={LoadingGif} alt="loading..." />
    <Typography color="primary" style={{ fontWeight: 600 }}>
      {message}
    </Typography>
  </div>
);
